<template>
    <div class="link-notice" :class="[`link-notice-shape-${shape}`]">
        <div class="link-notice-default" v-if="!renderFunc">
            <div class="link-notice-default-content-title"
                 :style="{backgroundColor:MODAL_TYPES[type].color,color:'white'}">
                <div>
                    <link-icon :icon="MODAL_TYPES[type].icon"/>
                    <span class="link-notice-default-content-text">{{title}}</span>
                </div>
                <link-icon icon="link-icon-close" @click="close" class="link-notice-default-content-close-icon" v-if="!!closable"/>
            </div>
            <div class="link-notice-default-content-message">{{message}}</div>
        </div>
        <div class="link-notice-render" v-if="!!renderFunc">
            <link-rendering-render-func :render-func="renderFunc"/>
        </div>
    </div>
</template>

<script>

    import LinkIcon from '../icon/link-icon';
    import LinkRenderingRenderFunc from '../render/link-rendering-render-func';

    export const MODAL_TYPES = {
        primary: {icon: 'icon-info-circle-fill', color: '#2D8DF0'},
        info: {icon: 'icon-info-circle', color: '#808695'},
        success: {icon: 'icon-checked-circle-fill', color: '#43B973'},
        warn: {icon: 'icon-alert', color: '#ffb020'},
        error: {icon: 'icon-close-circle-fill', color: '#ED4114'},
    };

    export default {
        name: 'link-notice',
        components: {
            LinkIcon,
            LinkRenderingRenderFunc
        },
        props: {
            duration: {
                type: Number,
                default: 3000,
            },
            message: {
                type: String,
            },
            title: {
                type: String,
                default: 'Notice Title',
            },
            closable: {
                type: Boolean,
                default: true,
            },
            autoClose: {
                type: Boolean,
                default: true,
            },
            type: {
                type: String,
                default: 'info',
                validator(val) {
                    return LinkUtils.oneOf(val, ['primary', 'info', 'success', 'warn', 'error']);
                },
            },
            shape: {
                type: String,
                default: 'fillet',
                validator(val) {
                    return LinkUtils.oneOf(val, ['fillet', 'none']);
                },
            },
            renderFunc: {
                type: Function,
            },
        },
        data() {
            return {
                MODAL_TYPES,
            };
        },
        methods: {
            close() {
                this.$emit('close');
            },
        },
        mounted() {
            !!this.autoClose && setTimeout(() => this.close(), this.duration);
        },
    };
</script>
